import { Iterable } from 'immutable'
import {
    configureStore,
    createSerializableStateInvariantMiddleware,
    isPlain,
    combineReducers
} from '@reduxjs/toolkit';
import organizationReducer from './features/organizationSlice';
import practitionerReducer from './features/practitionerSlice';
import userReducer from './features/userSlice';
import personReducer from './features/personSlice';
import clientReducer from './features/clientSlice';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const isSerializable = (value) => Iterable.isIterable(value) || isPlain(value)

const getEntries = (value) =>
    Iterable.isIterable(value) ? value.entries() : Object.entries(value)

const serializableMiddleware = createSerializableStateInvariantMiddleware({
    isSerializable,
    getEntries,
})

const persistConfig = {
    key: 'root',
    storage
};

const rootReducer = combineReducers({
    organization: organizationReducer,
    practitioner: practitionerReducer,
    user: userReducer,
    person: personReducer,
    client: clientReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                isSerializable: serializableMiddleware
            }
        })
});

export const persistor = persistStore(store);